var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{style:({color: _vm.styleColor}),attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n    "+_vm._s(_vm.shotName)+"\n  ")]),_vm._v(" "),_c('span',[_vm._v("\n  "+_vm._s(_vm.shotName)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d627ad66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sales/case/CaseServiceLogEvent.vue
// module id = null
// module chunks = 